import { OutputOptions, OutputResult } from "./types";
import { OutputFormatter } from "./formatter";

export class OutputHandler {
  constructor(private options: OutputOptions) {}

  output<T>(data: T, command?: string): void {
    const result = OutputFormatter.formatSuccess(data, command || "unknown");
    const formatted = OutputFormatter.format(result, this.options);

    if (formatted) {
      console.log(formatted);
    }
  }

  error(error: any): never {
    const result = OutputFormatter.formatError(error, this.options.verbose);
    const formatted = OutputFormatter.format(result, this.options);

    console.log(formatted);

    if (this.options.exitOnError) {
      process.exit(1);
    }
    throw error;
  }

  success(message: string, data?: any): void {
    const result: OutputResult = {
      success: true,
      data: data ? { message, ...data } : { message },
      metadata: {
        timestamp: new Date().toISOString(),
        command: process.argv.slice(2).join(" "),
      },
    };

    const formatted = OutputFormatter.format(result, this.options);
    console.log(formatted);
  }

  warn(message: string, data?: any): void {
    const result: OutputResult = {
      success: true,
      data: { warning: message, ...data },
      metadata: {
        timestamp: new Date().toISOString(),
        command: process.argv.slice(2).join(" "),
      },
    };

    const formatted = OutputFormatter.format(result, this.options);
    console.warn(formatted);
  }
}
